import { FC } from 'react'

const KlarnaIcon: FC = () => (
  <svg
    width="40"
    height="26"
    viewBox="0 0 40 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="40"
      height="25"
      rx="4"
      fill="#FFA8CD"
    />
    <path
      d="M25.2383 5H21.8461C21.8461 7.78984 20.1391 10.2898 17.5445 12.0758L16.525 12.7898V5H13V20.625H16.525V12.8797L22.3555 20.625H26.657L21.0477 13.2141C23.5977 11.3617 25.2602 8.48203 25.2383 5Z"
      fill="#0B051D"
    />
  </svg>
)

export default KlarnaIcon
